var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDesignerOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9466 17.4958L13.7566 20.0158C14.1266 20.4858 14.8366 21.2558 15.9566 21.7358C17.7766 22.5158 20.1966 22.3058 21.5566 21.0458C23.2666 19.4658 23.0466 16.5658 23.0466 16.5658C21.4466 17.9758 19.5366 17.6758 18.6866 17.2458C17.3865 16.5858 17.2866 14.6058 17.6366 11.4158C18.2066 6.21576 17.1066 2.44576 11.5566 1.72576C8.68655 1.35576 6.25655 2.58576 5.09655 3.46576C1.57655 6.18576 0.75655 12.9158 3.93655 19.6858L4.02655 19.9058C2.15655 15.5358 9.16655 13.3358 11.0866 9.98576C11.9366 8.50576 12.0365 7.17576 11.9265 6.21576C14.0865 6.70576 14.5666 8.69576 14.4166 10.5558C14.2966 12.0958 14.5666 13.3558 14.3865 14.4158C14.2065 15.4758 13.6266 16.6158 12.7466 17.2358C12.5466 17.3758 12.2666 17.4558 11.9466 17.4758V17.4958Z",
    fill: "#E79E49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57654 14.5757C6.57654 14.5757 7.25654 18.9557 6.37654 20.8757C5.70654 22.2157 3.95654 22.3357 3.95654 22.3357",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3565 17.5757C11.3565 17.5757 11.1465 19.6957 11.3565 20.8157C11.6765 22.5157 13.7465 22.3357 13.7465 22.3357",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44629 17.2254C9.44629 17.2254 11.8663 17.9354 12.7463 17.3154C13.6263 16.6954 14.1963 15.5554 14.3863 14.4954C14.5763 13.4354 14.2963 12.1754 14.4163 10.6354C14.5663 8.77541 14.0863 6.78541 11.9263 6.29541",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7468 5.40576C12.0068 6.30576 12.2368 8.04576 11.0868 10.0658C8.9668 13.7858 0.576801 16.0758 4.9668 21.4958",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9465 17.5758L13.7565 20.0958C14.1265 20.5658 14.8365 21.3358 15.9565 21.8158C17.7765 22.5958 20.1965 22.3858 21.5565 21.1258C23.2665 19.5458 23.0465 16.6458 23.0465 16.6458C21.4465 18.0558 19.5365 17.7558 18.6865 17.3258C17.3865 16.6658 17.2865 14.6858 17.6365 11.4958C18.2065 6.29584 17.1065 2.52584 11.5565 1.80584C8.6865 1.43584 6.2565 2.66584 5.0965 3.54584C1.5465 6.27584 0.736505 13.0958 4.0065 19.9258",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDesignerOn);
export default __webpack_public_path__ + "static/media/ic_designer_on.a3e45b6a999f1a690f1b712b2e193176.svg";
export { ForwardRef as ReactComponent };